module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_4_1.80845d3c.jpeg";